import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Chip from '@material-ui/core/Chip';
import { DataTypeProvider, } from '@devexpress/dx-react-grid'

export default class RoleTypeProvider extends Component {
  render() {
    return(
      <DataTypeProvider
        for={this.props.for}
        formatterComponent={({ value }) => { return(value ? <Chip label={value} /> : <div />) } }
        editorComponent={({ column, row, value, onValueChange }) => <div /> }
      />
    );
  }
}

RoleTypeProvider.propTypes = {
  for: PropTypes.array.isRequired,
}
